import styled from "styled-components";

export const HeroTitle = styled.h1`
    width: 100%;
    background-color: transparent;
`
export const ParaFont = styled.p`
    color: red;
    font-style: italic;
    font-weight: 200;
    background: black;
`
export const MainBody = styled.body`
    background-color: red;
`

export const HomePage = styled.div`
    display:flex;
    flex-direction: column;
    align-items:center;
`;